"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnlineProximityLookup = void 0;
const client_1 = require("@apollo/client");
const aggregate_1 = require("../utils/aggregate");
const configContext_1 = require("../contexts/configContext");
// TODO [S5-3129]: Rename to Online (along with `useOfflineDataLookup.ts`) when mobile/desktop offline strategy is implemented.
const useOnlineProximityLookup = () => {
    const { aggregateDefinitions } = (0, configContext_1.useConfig)();
    const apolloClient = (0, client_1.useApolloClient)();
    const onlineLookup = (aggregateTypes, centerLatitude, centerLongitude, proximityDistance, distanceUnit, limit) => {
        return apolloClient
            .query({
            query: (0, client_1.gql) `
          query proximityLookup { aggregateProximity( filter: {
            ${aggregateTypes ? `aggregateTypes: [${aggregateTypes.map(a => `"${a}"`).join(',')}],` : ''}
            centerLongitude: ${centerLongitude},
            centerLatitude: ${centerLatitude},
            proximityDistance: ${proximityDistance},
            distanceUnit: "${distanceUnit}",
            limit: ${limit}
          }) {
            record,
            type,
            distanceFromCenter
          } }
        `,
            fetchPolicy: 'no-cache',
        })
            .then(res => {
            var _a;
            return ((_a = res.data) === null || _a === void 0 ? void 0 : _a.aggregateProximity)
                ? res.data.aggregateProximity.map(({ record, type, distanceFromCenter }) => ({
                    record: (0, aggregate_1.graphqlToAssetTransform)({
                        flattenRelationships: true,
                        result: record,
                        aggDef: aggregateDefinitions.find(a => a.name === type),
                    }),
                    type,
                    distanceFromCenter,
                }))
                : [];
        });
    };
    return onlineLookup;
};
exports.useOnlineProximityLookup = useOnlineProximityLookup;
//# sourceMappingURL=useOnlineProximityLookup.js.map